/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { IntermediateEvent } from "./IntermediateEvent";
import {
  IntermediateEventFromJSON,
  IntermediateEventFromJSONTyped,
  IntermediateEventToJSON,
  IntermediateEventToJSONTyped,
} from "./IntermediateEvent";

/**
 *
 * @export
 * @interface ApiGmnEventsList200Response
 */
export interface ApiGmnEventsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGmnEventsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmnEventsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmnEventsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<IntermediateEvent>}
   * @memberof ApiGmnEventsList200Response
   */
  results: Array<IntermediateEvent>;
}

/**
 * Check if a given object implements the ApiGmnEventsList200Response interface.
 */
export function instanceOfApiGmnEventsList200Response(
  value: object
): value is ApiGmnEventsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGmnEventsList200ResponseFromJSON(json: any): ApiGmnEventsList200Response {
  return ApiGmnEventsList200ResponseFromJSONTyped(json, false);
}

export function ApiGmnEventsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmnEventsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(IntermediateEventFromJSON),
  };
}

export function ApiGmnEventsList200ResponseToJSON(json: any): ApiGmnEventsList200Response {
  return ApiGmnEventsList200ResponseToJSONTyped(json, false);
}

export function ApiGmnEventsList200ResponseToJSONTyped(
  value?: ApiGmnEventsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(IntermediateEventToJSON),
  };
}
